<template>
  <!-- Formulário de análise: visível somente para usuários FUNDACAO -->
  <div class="box box-primary" id="analise" v-if="usuarioLogado.userType === 'FUNDACAO'">
    <div class="box-header with-border">
      <h3 class="box-title"><i class="fa fa-caret-right" aria-hidden="true"></i> <font style="color:#048019;">Análise da Proposta</font></h3><span style="color:#a8a8a8;" v-if="analise.ds_codigo_projeto_erp"> - &nbsp;N°Projeto: <b>{{analise.ds_codigo_projeto_erp}}</b></span>
    </div>
    <div class="box-body">
      <div v-if="usuarioLogado.userType === 'FUNDACAO' && ehSimplificada" style="color: red;">
        Proposta Simplificada
      </div>
      <fieldset>
      <div class="form-horizontal">
        <fieldset :disabled="bloqueia === true">
        <!--Agência condutora do Projeto-->
        <!--<agencia-condutora-projeto :propsProposta="analise" @agenciaSelecionada="analise = $event"></agencia-condutora-projeto>-->
          <!--FEP-->
          <div v-if="_.isNull(analise.fep) || _.isUndefined(analise.fep) || _.isEmpty(analise.fep) || analise.fep === ''">
             <span class="mensagem naoPreenchido">FEP ainda não gerada no sistema. É necessário informar o número da FEP</span>
            <div class="box-body">
              <div class="row">
                <div class="col-md-2">
                  <input type="number" class="form-control" placeholder="Qual vai ser o número da FEP?" v-model="numeroFepInformado" min="0" max="999" step="1">
                  <p style="margin-top:10px">{{ resultadoVerificacaoFepExistente }}</p>
                </div>
                <button :disabled="_.isNull(numeroFepInformado) || _.isEmpty(numeroFepInformado) || (+numeroFepInformado < 1 || +numeroFepInformado > 999)" @click="criaNovaFep(numeroFepInformado)" class="btn btn-primary btn-sm btn-flat" style="text-decoration: none" type="button"><i class="fa fa-file-text-o" aria-hidden="true"></i>&nbsp Gerar FEP</button>
              </div>
            </div>
          </div>
          <div>
            <fieldset :disabled="this.$router.currentRoute.name === 'proposta-visualiza' || analise.ds_fase !== 'ANALISE'" id="fep">
              <fep v-if="!_.isNull(analise) && !_.isEmpty(analise)" :propsAnalise="propsAnalise"></fep>
            </fieldset>
          </div>
          <!-- 69906 - Marcação de ODS no projeto -->
          <fieldset>
            <odsMarcacao :proposta="this.$route.params.id" :telaProjeto="false" id="odsMarcacao"/>
          </fieldset>

          <fieldset>
            <licenciamentoAmbientalAnalise ref="licenciamentoAnalise" :idProposta="this.$route.params.id" :novaCarga="novaCarga"/>
          </fieldset>

          <!--Relatório da análise-->
          <fieldset :disabled="bloqueia === true" id="relatorioAnalise">
            <div style="background-color: #fcfcfc">
            <legend>&nbsp;Relatório da Análise</legend>
            </div>
            <!--<font color="#696969">Situação: <b>{{preenchimentoRelatorio}}</b></font>-->
            <!--<br>-->
            <br>
            <div>
              <legend :disabled="false">
                <fieldset v-if="analise.ds_fase === 'ANALISE'">
                  <router-link :to="{name: 'relatorio-analise', params: { id: analise.id } }" target="_blank" class="btn btn-primary btn-sm btn-flat" style="text-decoration: none"><i class="fa fa-pencil-square-o"></i> Preencher Relatório</router-link>
                  <router-link :to="{name: 'visualiza-relatorio-analise', params: { id: analise.id, projeto: analise.ds_codigo_projeto_erp } }" target="_blank" class="btn btn-success btn-sm btn-flat" style="text-decoration: none"><i class="fa fa-search"></i> Visualizar Relatório</router-link>
                </fieldset>
                <fieldset v-else>
                  <router-link :to="{name: 'relatorio-analise', params: { id: analise.id } }" target="_blank" class="btn btn-primary btn-sm btn-flat" style="text-decoration: none"><i class="fa fa-search"></i> Visualizar Relatório</router-link>
                </fieldset>
              <!--<b-button type="button" :disabled="false" @click="showModal = true" class="btn btn-primary btn-sm btn-flat"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>&nbsp Preencher Relatório</b-button>-->
                <!--<router-link :to="{name: 'relatorio-analise', params: { id: analise.id } }" target="_blank" class="btn btn-primary btn-sm btn-flat" style="text-decoration: none"><i class="fa fa-pencil-square-o"></i> Preencher Relatório</router-link>-->
              </legend>
            </div>
            <span v-if="_.isNull(analise.relatorio_analise)" class="mensagem naoPreenchido"> Relatório da Análise não preenchido ainda</span>
            <div id="app">
              <div v-if="showModal" id="modal4">
                <transition name="modal" id="modal">
                  <div class="modal-mask" id="modal3">
                    <div class="modal-wrapper" @click="$emit(showModal=true)" id="modal1">
                      <div class="modal-dialog" id="modal2">
                        <div class="modal-content" @click.stop>
                          <div class="modal-header">
                            <button type="button" class="close" @click="showModal=false">
                              <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 class="modal-title">Relatório da Análise</h4>
                          </div>
                          <relatorio-analise :propsProposta="analise"></relatorio-analise>
                          <div class="box-body">
                          </div>
                          <div class="box-footer">
                            <b-button type="button" :disabled="false" @click="showModal = false" class="btn btn-primary btn-sm btn-flat"><i class="fa fa-floppy-o" aria-hidden="true"></i>  Salvar </b-button>
                            <b-button type="button" :disabled="false" @click="showModal = false" class="btn btn-warning btn-sm btn-flat"><i class="fa fa-close" aria-hidden="true"></i>  Fechar </b-button>
                          </div>
                          <div align="right">
                            <br>
                          </div></div></div></div></div>
                </transition>
              </div>
            </div>
          </fieldset>
          <br>

          <!-- Rating da entidade -->
          <!--<rating :propsAnalise="analise" @ratingCalculado="analise.rating = $event"></rating>-->
            <div class="box box-widget"  v-if="!ehSimplificada" id="ratingEntidade">
              <div class=" with-border">
                <div class="form-horizontal" style="background-color: #FCFCFC">
                   <legend class="box-title">&nbsp;Rating da Entidade</legend>
                </div>
            <br>
                <fieldset v-if="analise.ds_fase === 'ANALISE'">
                    <router-link v-if="!ehSimplificada" :to="{name: 'relatorio-rating', params: { id: analise.id }, query : { entidade: analise.entidade.id} }" target="_blank" class="btn btn-primary btn-sm btn-flat" style="text-decoration: none"><i class="fa fa-pencil-square-o"></i> Calcular o Rating da Entidade</router-link>
                </fieldset>
                <fieldset v-else>
                  <router-link v-if="!ehSimplificada" :to="{name: 'relatorio-rating', params: { id: analise.id }, query : { entidade: analise.entidade.id} }" target="_blank" class="btn btn-primary btn-sm btn-flat" style="text-decoration: none"><i class="fa fa-search"></i> Visualizar o Rating da Entidade</router-link>
                </fieldset>
              </div><br></div>
          <!--Questionario de riscos-->
          <questionario-riscos :key="questRiscKey" :disabled="this.$router.currentRoute.name === 'proposta-visualiza' || analise.ds_fase !== 'ANALISE'" v-if="analise.ds_fase !== 'CADASTRO'" :propsAnalise="propsAnalise"  @questionario="analise.questionario_respostas = (Array.isArray($event) && $event.length === 0) ? {} : $event" ref="child" :ehSimplificada="ehSimplificada" id="questionarioRiscos"></questionario-riscos>
          <!--Categorizadores-->
          <categorizadores v-if="analise" :propsAnalise="propsAnalise" :indicativoAvaliacao="indicativoAvaliacao" :ehSimplificada="ehSimplificada" ></categorizadores>
        </fieldset>
        <span v-if="analise.edital === null">
          <fieldset :disabled="this.$router.currentRoute.name === 'proposta-visualiza' || analise.ds_fase !== 'ANALISE'" v-if="!ehSimplificada">
            <questoesAvaliacaoProjeto ref="questoesAvaliacao" :idProposta="analise.id" :resultadoAprovacao="propsAnalise.resultadoAprovacao" :proximaEtapa="propsAnalise.proximaEtapa"/>
          </fieldset>
        </span>
        <!--Elementos Característicos-->
        <fieldset :disabled="this.$router.currentRoute.name === 'proposta-visualiza' || analise.ds_fase !== 'ANALISE'">
        <!-- <div class="row" :disabled="bloqueia === true">
          <div class="form-group col-md-12 required-field" style="margin-left:0px; margin-right:0px;"
               :class="{ 'has-error' : errors.first('elementos característicos')}">
            <label class="control-label">Elementos característicos</label>
            <textarea-autosize v-resizable @input="resizable" v-model="analise.ds_caracteristicas_formalizacao" style="height:150px;resize:none;" name="elementos característicos" data-vv-as="Elementos Característicos"
                               class="form-control" v-validate="'required'"></textarea-autosize>
            <span v-if="errors.first('elementos característicos')" class="label label-danger"> {{ errors.first('elementos característicos') }}</span>
          </div>
        </div> -->
        <!--Indicadores de Resultado (checklist dinâmico por Programa)-->
        <div class="row" :disabled="bloqueia === true">
          <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
            <label class="control-label">Indicadores de Resultado</label>
            <checklist-indicadores
              :opcoes="opcoesIndicadores"
              :disabled="bloqueia === true"
              v-model="analise.dados.indicadores_resultado">
            </checklist-indicadores>
          </div>
        </div>
        <!--Ações de Comunicação-->
        <div class="row" :disabled="bloqueia === true">
          <div class="form-group col-md-12 required-field" style="margin-left:0px; margin-right:0px;"
               :class="{ 'has-error' : errors.first('acoes')}">
            <label for="acoes" class="control-label">Ações de Comunicação</label>
            <div>
              <textarea placeholder="Informe as acões de comunicação" data-vv-as="Ações" style="min-height:150px;resize:vertical;" v-model="analise.ds_acoes_comunicacao" name="acoes" class="form-control" rows="6"
                        v-validate="'required'"></textarea>
            </div>
            <span v-if="errors.first('acoes')" class="label label-danger"> {{ errors.first('acoes') }}</span>
          </div>
        </div>

        <!--Periodicidade da apresentação dos relatórios de execução-->
        <fieldset :disabled="bloqueia === true" id="periodicidadeRelatorio">
          <div  style="background-color: #FCFCFC">
           <legend>&nbsp;Periodicidade da apresentação dos relatórios de execução</legend>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group col-md-12 required" :class="{ 'has-error' : errors.first('periodicidade')}">
                <label class="control-label">Periodicidade da apresentação dos relatórios de execução</label>
                <select name="periodicidade"
                        v-model="analise.ds_periodicidade_formulario"
                        class="form-control"
                        aria-hidden="true"
                        v-validate="'required'">
                  <option v-for="i in reportPeriodicity" :value="i.id">{{i.name}}</option>
                </select>
                <span v-if="errors.first('periodicidade')" class="label label-danger"> {{ errors.first('periodicidade') }}</span>
              </div>
            </div>
          </div>
        </fieldset>
        <!--Campos Estratégicos - visível apenas para FUNDACAO-->
        <fieldset v-if="usuarioLogado.userType === 'FUNDACAO'" :disabled="bloqueia === true" id="camposEstrategicos">
          <div style="background-color: #FCFCFC">
            <legend>&nbsp;Informações Estratégicas</legend>
          </div>

          <!--Temática do Projeto (obrigatório para concluir a análise)-->
          <div class="row">
            <div class="form-group col-md-12 required-field" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Temática do Projeto</label>
              <div class="row" style="margin-left:0; margin-right:0; margin-top:6px;">
                <div v-for="(item, idx) in tematicaProjetoOpcoes" :key="idx" class="col-md-4" style="padding:3px 15px;">
                  <label class="new-control new-control-checkbox" style="padding-top:4px; font-weight:normal; cursor:pointer;">
                    <input type="checkbox" :value="item" v-model="analise.dados.tematica_projeto">
                    &nbsp;{{ item }}
                    <div class="new-control-indicator"></div>
                  </label>
                </div>
              </div>
              <div v-if="tematicaOutrosSelecionado" class="row" style="margin-left:0; margin-right:0; margin-top:6px;">
                <div class="col-md-6" style="padding-left:0;">
                  <input type="text" class="form-control" maxlength="255" placeholder="Descreva a(s) outra(s) temática(s)" v-model="analise.dados.tematica_projeto_outros">
                </div>
              </div>
              <span style="color:#a8a8a8; font-size:13px;">Preenchimento obrigatório para concluir a análise.</span>
            </div>
          </div>

          <!--Direcionadores Estratégicos (Ação Estratégica)-->
          <div class="row" style="margin-top:4px;">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Ação Estratégica</label>
              <div class="row" style="margin-left:0; margin-right:0; margin-top:6px;">
                <div v-for="(item, idx) in direcionadoresEstrategicosOpcoes" :key="idx" class="col-md-4" style="padding:3px 15px;">
                  <label class="new-control new-control-checkbox" style="padding-top:4px; font-weight:normal;" :style="{ cursor: ehDirecionadorAutomatico(item) ? 'not-allowed' : 'pointer' }">
                    <input type="checkbox" :value="item" v-model="analise.dados.direcionadores_estrategicos" :disabled="ehDirecionadorAutomatico(item)">
                    &nbsp;{{ item }}
                    <div class="new-control-indicator"></div>
                  </label>
                  <span v-if="textoAjudaDirecionador(item)" class="ajuda-direcionador"
                        :class="{ 'ajuda-direcionador-esquerda': (idx % 3) === 2 }">
                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                    <span class="ajuda-direcionador-texto">{{ textoAjudaDirecionador(item) }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!--Comunicadores Populares (no relatório aparece em Ações de Comunicação, só quando marcado)-->
          <div class="row" style="margin-top:4px;">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Comunicadores Populares</label>
              <div style="margin-top:6px;">
                <label class="new-control new-control-checkbox" style="padding-top:4px; font-weight:normal; cursor:pointer;">
                  <input type="checkbox" v-model="analise.dados.comunicadores_populares">
                  &nbsp;O projeto possui Comunicadores Populares
                  <div class="new-control-indicator"></div>
                </label>
              </div>
            </div>
          </div>

          <!--Histórico da Proponente (não exibido no relatório/proposta simplificada)-->
          <div class="row" style="margin-top:4px;" v-if="!ehSimplificadaRelatorio">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Histórico da Proponente</label>
              <textarea v-model="analise.dados.historico_proponente" class="form-control" style="min-height:150px;resize:vertical;" rows="6" :placeholder="placeholderHistoricoProponente"></textarea>
            </div>
          </div>

          <!--Perfil Territorial (exibido no relatório de análise; não exibido no simplificado)-->
          <div class="row" style="margin-top:4px;" v-if="!ehSimplificadaRelatorio">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Perfil Territorial</label>
              <textarea v-model="analise.dados.perfil_territorial" class="form-control" style="min-height:150px;resize:vertical;" rows="6" placeholder="Informações sobre o território, dados sobre a atuação da entidade e se já atua em rede"></textarea>
            </div>
          </div>

          <!--Objeto do Convênio (uso interno; não vai para o relatório de análise)-->
          <div class="row" style="margin-top:4px;">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Objeto do Convênio</label>
              <textarea v-model="analise.dados.objeto_convenio" class="form-control" style="min-height:150px;resize:vertical;" rows="6" placeholder="Descreva o objeto do convênio"></textarea>
            </div>
          </div>

          <!--Priorização de Público: dirigente indígena/quilombola e povos abrangidos-->
          <div style="background-color: #FCFCFC; margin-top:10px;">
            <legend>&nbsp;Priorização de Público</legend>
          </div>

          <!--Dirigente indígena ou quilombola-->
          <div class="row" style="margin-top:4px;">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Dirigente Indígena ou Quilombola</label>
              <div style="margin-top:6px;">
                <label class="new-control new-control-checkbox" style="padding-top:4px; font-weight:normal; cursor:pointer;">
                  <input type="checkbox" v-model="analise.dados.dirigente_indigena_quilombola">
                  &nbsp;A entidade possui dirigente indígena ou quilombola
                  <div class="new-control-indicator"></div>
                </label>
              </div>
            </div>
          </div>

          <!--Povos Indígenas-->
          <div class="row" style="margin-top:4px;">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Povos Indígenas abrangidos</label>
              <multiselect v-model="analise.dados.povos_indigenas"
                           :options="povosIndigenasOpcoes"
                           :multiple="true"
                           :close-on-select="false"
                           :clear-on-select="false"
                           :preserve-search="true"
                           :searchable="true"
                           :taggable="true"
                           @tag="adicionaPovoIndigena"
                           tag-placeholder="Pressione enter para adicionar este povo"
                           :disabled="bloqueia === true"
                           placeholder="Busque e selecione os povos indígenas abrangidos (se houver)"
                           selectLabel="" deselectLabel="" selectedLabel="Selecionado">
                <span slot="noResult">Nenhum povo localizado. Digite e pressione enter para adicionar.</span>
                <span slot="noOptions">Nenhum povo cadastrado. Digite e pressione enter para adicionar.</span>
              </multiselect>
              <span style="color:#a8a8a8; font-size:13px;">Deixe em branco caso o projeto não abranja povos indígenas.</span>
            </div>
          </div>

          <!--Povos Quilombolas-->
          <div class="row" style="margin-top:4px;">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Povos Quilombolas abrangidos</label>
              <multiselect v-model="analise.dados.povos_quilombolas"
                           :options="povosQuilombolasOpcoes"
                           :multiple="true"
                           :close-on-select="false"
                           :clear-on-select="false"
                           :preserve-search="true"
                           :searchable="true"
                           :taggable="true"
                           @tag="adicionaPovoQuilombola"
                           tag-placeholder="Pressione enter para adicionar este povo"
                           :disabled="bloqueia === true"
                           placeholder="Busque e selecione os povos quilombolas abrangidos (se houver)"
                           selectLabel="" deselectLabel="" selectedLabel="Selecionado">
                <span slot="noResult">Nenhum povo localizado. Digite e pressione enter para adicionar.</span>
                <span slot="noOptions">Nenhum povo cadastrado. Digite e pressione enter para adicionar.</span>
              </multiselect>
              <span style="color:#a8a8a8; font-size:13px;">Deixe em branco caso o projeto não abranja povos quilombolas.</span>
            </div>
          </div>

          <!--Contexto Territorial (exibido no simplificado e no completo)-->
          <fieldset id="contextoTerritorial" style="margin-top:12px;">
            <div style="background-color: #FCFCFC">
              <legend>&nbsp;Contexto Territorial</legend>
            </div>

            <!--I) Características Geográficas-->
            <div class="row" style="margin-left:0; margin-right:0; margin-top:10px;">
              <div class="col-md-12">
                <label class="control-label" style="margin-bottom:6px;">I) Características Geográficas</label>
                <div class="row" style="margin-left:0; margin-right:0;">
                  <div v-for="(item, idx) in caracteristicasGeograficasOpcoes" :key="idx" class="col-md-4" style="padding:3px 15px;">
                    <label class="new-control new-control-checkbox" style="padding-top:4px; font-weight:normal; cursor:pointer;">
                      <input type="checkbox" :value="item" v-model="analise.dados.contexto_caracteristicas_geograficas">
                      &nbsp;{{ item }}
                      <div class="new-control-indicator"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!--II) Biomas-->
            <div class="row" style="margin-left:0; margin-right:0; margin-top:12px; margin-bottom:10px;">
              <div class="col-md-12">
                <label class="control-label" style="margin-bottom:6px;">II) Biomas</label>
                <div class="row" style="margin-left:0; margin-right:0;">
                  <div v-for="(item, idx) in biomasOpcoes" :key="idx" class="col-md-4" style="padding:3px 15px;">
                    <label class="new-control new-control-checkbox" style="padding-top:4px; font-weight:normal; cursor:pointer;">
                      <input type="checkbox" :value="item" v-model="analise.dados.contexto_biomas">
                      &nbsp;{{ item }}
                      <div class="new-control-indicator"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </fieldset>
        <!--Fim do primeiro bloco de campos estratégicos-->

        <!--Segundo bloco de campos estratégicos — checklist e análise.
            O parecer jurídico (campo legado) fica dentro do Checklist da Análise,
            antes do grupo "Enquadramento e Parecer Jurídico".-->
        <fieldset v-if="usuarioLogado.userType === 'FUNDACAO'" :disabled="bloqueia === true" id="analiseDetalhada">
          <!--Situação Problema (exibida no relatório completo; não exibida no simplificado)-->
          <div class="row" style="margin-top:12px;" v-if="!ehSimplificadaRelatorio">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Situação Problema</label>
              <textarea v-model="analise.dados.situacao_problema" class="form-control" style="min-height:200px;resize:vertical;" rows="10" placeholder="Descreva a situação problema que o projeto pretende enfrentar"></textarea>
            </div>
          </div>

          <!--Proposta de Solução e Sustentabilidade (chave 'analise'; no relatório vem logo após a Situação Problema; não exibida no simplificado)-->
          <div class="row" v-if="!ehSimplificadaRelatorio">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Proposta de Solução e Sustentabilidade</label>
              <textarea v-model="analise.dados.analise" class="form-control" style="min-height:200px;resize:vertical;" rows="10" :placeholder="placeholderAnalise"></textarea>
            </div>
          </div>

          <!--Distribuição e Informações dos Recursos (chave 'analise_tecnica'; não exibida no simplificado)-->
          <div class="row" v-if="!ehSimplificadaRelatorio">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <div style="display:flex; align-items:center; justify-content:space-between; gap:8px; margin-bottom:5px;">
                <label class="control-label" style="margin:0;">Distribuição e Informações dos Recursos</label>
                <button type="button" class="btn btn-default btn-sm btn-flat"
                        v-confirm="{ok: retorno => geraAnaliseTecnica(), cancel: () => {}, message: 'O texto atual da <b>Distribuição e Informações dos Recursos</b> será substituído pela lista de atividades e valores. Deseja continuar?'}">
                  <i class="fa fa-refresh"></i> Gerar novamente
                </button>
              </div>
              <textarea v-model="analise.dados.analise_tecnica" class="form-control" style="min-height:200px;resize:vertical;" rows="10" placeholder="Descreva a distribuição dos recursos por atividade e as informações relevantes"></textarea>
            </div>
          </div>

          <!--Checklist da Análise (perguntas migradas da antiga tela de Relatório de Análise)-->
          <fieldset id="checklistAnalise" style="margin-top:12px;">
            <div style="background-color: #FCFCFC">
              <legend>&nbsp;Checklist da Análise</legend>
            </div>
            <checklist-analise :dados="analise.dados" :disabled="bloqueia === true">
              <!--Ocorrências impeditivas da entidade no Sapiens, para apoiar as respostas de regularidade-->
              <template v-if="restricoesEntidade" slot="inicio-regularidade">
                <quadro-restricoes-entidade :restricoes="restricoesEntidade"></quadro-restricoes-entidade>
              </template>
              <!--Parecer jurídico posicionado antes do grupo "Enquadramento e Parecer Jurídico"-->
              <template slot="antes-enquadramento">
                <fieldset style="margin-bottom:12px;">
                  <div style="background-color: #FCFCFC">
                    <legend>&nbsp;Parecer jurídico</legend>
                  </div>
                  <parecer-juridico-campos :analise="analise"></parecer-juridico-campos>
                </fieldset>
              </template>
            </checklist-analise>
          </fieldset>

          <!--Pontos de Atenção e Elementos Mitigadores (não exibido no simplificado)-->
          <fieldset id="pontosAtencaoMitigadores" style="margin-top:12px;" v-if="!ehSimplificadaRelatorio">
            <div style="background-color: #FCFCFC">
              <legend>&nbsp;Pontos de Atenção e Elementos Mitigadores</legend>
            </div>
            <!--Cabeçalho das colunas (alinhado aos campos abaixo)-->
            <div style="display:flex; gap:16px; margin-bottom:6px;">
              <label class="control-label" style="flex:1; margin:0; text-align:left;">Ponto de Atenção</label>
              <label class="control-label" style="flex:1; margin:0; text-align:left;">Elemento Mitigador</label>
              <div style="width:52px; flex:none;"></div>
            </div>
            <div v-for="(item, idx) in analise.dados.pontos_atencao_mitigadores" :key="idx" style="display:flex; gap:16px; align-items:flex-start; margin-bottom:8px;">
              <div style="flex:1;">
                <input v-model="item.risco" type="text" class="form-control" placeholder="Descreva o ponto de atenção" maxlength="255">
              </div>
              <div style="flex:1;">
                <input v-model="item.mitigador" type="text" class="form-control" placeholder="Descreva o elemento mitigador" maxlength="255">
              </div>
              <div style="width:52px; flex:none;">
                <button type="button" @click="removeRiscoMitigador(idx)" class="btn btn-danger btn-sm btn-flat" :disabled="analise.dados.pontos_atencao_mitigadores.length === 1">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
            <div style="margin-top:8px;">
              <button type="button" @click="addRiscoMitigador()" class="btn btn-default btn-sm btn-flat">
                <i class="fa fa-plus"></i> Adicionar Ponto de Atenção/Mitigador
              </button>
            </div>
          </fieldset>

          <!--Condicionantes (não exibido no simplificado)-->
          <div class="row" style="margin-top:12px;" v-if="!ehSimplificadaRelatorio">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Condicionantes</label>
              <textarea-autosize v-resizable @input="resizable" v-model="analise.dados.condicionantes" name="condicionantes" class="form-control" style="height:120px;resize:none;" placeholder="Informe os requisitos que devem ser cumpridos antes da execução do projeto"></textarea-autosize>
            </div>
          </div>

          <!--Proposta-->
          <div class="row" style="margin-top:12px; margin-bottom:12px;">
            <div class="form-group col-md-12" style="margin-left:0px; margin-right:0px;">
              <label class="control-label">Proposta</label>
              <textarea-autosize v-resizable @input="resizable" v-model="analise.dados.conclusao_analise" name="propostaTexto" class="form-control" style="min-height:80px;resize:none;"></textarea-autosize>
            </div>
          </div>

          <!--Novo Relatório de Análise (Laravel) — abre autenticado via SSO handoff-->
          <fieldset id="novoRelatorioAnalise">
            <div style="margin: 8px 0;">
              <button type="button" @click="abreLaravelAutenticado('/sgp/propostas/' + $route.params.id + '/relatorio')" class="btn btn-primary btn-sm btn-flat" style="text-decoration: none">
                <i class="fa fa-search"></i> Visualizar Novo Relatório de Análise
              </button>
            </div>
          </fieldset>
        </fieldset>

        <!--Documentos-->
        <fieldset :disabled="bloqueia === true" id="documentosAnalise">
          <div  style="background-color: #FCFCFC">
          <legend>&nbsp;Documentos da Análise</legend>
          </div>
          <div class="col-md-12">
            <upload-documentos-php-novo :propDocumentos="documentosAnalise" :propsEtapa="analise.ds_fase" :documentTypes="dctos" :documentosObrigatorios="''" :local-uso="'TODOS'"></upload-documentos-php-novo>
          </div>
        </fieldset>
        </fieldset>
        <!--Decisões da análise da proposta-->
        <fieldset v-if="analise.ds_fase === 'ANALISE'" :disabled="bloqueia === true">
          <div  style="background-color: #FCFCFC">
          <legend>&nbsp;Decisões da análise da proposta</legend>
          </div>
          <div class="row">
            <div class="col-md-12" >
              <div class="form-group col-md-12" :class="{ 'has-error' : errors.first('resultadoAprovacao')}">
                <label class="control-label">Decisões</label>
                <div class="col-md-12">
                  <label class="new-control new-control-radio" style="padding-top: 8px;">
                    <input type="radio" name="resultadoAprovacao" value="ENCAMINHAR_DEFERIMENTO" @change="limparInfo()"
                           v-model="analise.resultadoAprovacao" v-validate="'required'"/> Encaminhar para deferimento
                    <div class="new-control-indicator"></div>
                  </label>
                </div>
                <div class="col-md-12">
                  <label class="new-control new-control-radio" style="padding-top: 8px;">
                    <input type="radio" name="resultadoAprovacao" value="DEVOLVER_ENTIDADE"
                           v-model="analise.resultadoAprovacao" v-validate="'required'"/> Devolver à entidade para ajustes
                    <div class="new-control-indicator"></div>
                  </label>
                </div>
                <div class="col-md-12">
                  <label class="new-control new-control-radio" style="padding-top: 8px;">
                    <input type="radio" name="resultadoAprovacao" value="INCLUIR_SAPIENS"
                           v-model="analise.resultadoAprovacao" v-validate="'required'"/> Criar projeto e retornar para análise
                    <div class="new-control-indicator"></div>
                  </label>
                </div>
                <div class="col-md-12">
                  <label class="new-control new-control-radio" style="padding-top: 8px;">
                    <input type="radio" name="resultadoAprovacao" value="ENVIAR_PENDENCIAS"
                           v-model="analise.resultadoAprovacao" v-validate="'required'"/> Enviar para pendências
                    <div class="new-control-indicator"></div>
                  </label>
                </div>
                <div class="col-md-12">
                  <label class="new-control new-control-radio" style="padding-top: 8px;">
                    <input type="radio" name="resultadoAprovacao" value="ANULAR_PROPOSTA"
                           v-model="analise.resultadoAprovacao" v-validate="'required'"/> Anular proposta
                    <div class="new-control-indicator"></div>
                  </label>
                </div>
              </div>
            </div>
            <span v-if="errors.first('resultadoAprovacao')" class="label label-danger"> {{('É necessário preencher uma decisão da Análise!') }}</span>
            <div class="col-md-12" v-if="analise.resultadoAprovacao === 'ENVIAR_PENDENCIAS'">
              <div class="form-group col-md-12 required-field"
                   :class="{ 'has-error' : errors.first('justificativa')}">
                <label class="control-label">Motivo da pendência</label>
                <textarea-autosize v-resizable @input="resizable" v-model="analise.observacao" style="height:150px; resize:none;"
                          name="justificativa"
                                   class="form-control" v-validate="'required'"></textarea-autosize>
                <span v-if="errors.first('justificativa')" class="label label-danger"> {{ errors.first('justificativa') }}</span>
              </div>
            </div>
            <div class="col-md-12" v-if="analise.resultadoAprovacao === 'DEVOLVER_ENTIDADE'">
              <div class="form-group col-md-12 required-field"
                   :class="{ 'has-error' : errors.first('justificativa')}">
                <label class="control-label">Motivo da pendência</label>
                <textarea-autosize v-resizable @input="resizable" v-model="analise.observacao" style="height:150px; resize:none;"
                          name="justificativa"
                                   class="form-control" v-validate="'required'"></textarea-autosize>
                <span v-if="errors.first('justificativa')" class="label label-danger"> {{ errors.first('justificativa') }}</span>
              </div>
            </div>
            <div class="col-md-12" v-if="analise.resultadoAprovacao === 'ANULAR_PROPOSTA'">
              <div class="form-group col-md-12 required-field"
                   :class="{ 'has-error' : errors.first('justificativa')}">
                <label class="control-label">Justificativa para reprovação</label>
                <textarea-autosize v-resizable @input="resizable" v-model="analise.observacao" style="height:150px; resize:none;"
                          name="justificativa"
                                   class="form-control" v-validate="'required'"></textarea-autosize>
                <span v-if="errors.first('justificativa')" class="label label-danger"> {{ errors.first('justificativa') }}</span>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
  import AgenciaCondutoraProjeto from '../../modules/agenciaCondutoraProjeto'
  import RelatorioAnalise from '../../modules/relatorioAnalise'
  import UploadDocumentosPhpNovo from '../../modules/uploadDocumentosPhpNovo'
  import Fav from '../../modules/fav'
  import QuestionarioRiscos from '../../modules/questionarioRiscos'
  import Fep from '../../modules/fep'
  import Categorizadores from '../../modules/categorizadores'
  import Rating from '../../modules/rating'
  import odsMarcacao from '../../modules/odsMarcacao'
  import licenciamentoAmbientalAnalise from '../../modules/licenciamentoAmbiental/licenciamentoAmbientalAnalise.vue'
  import questoesAvaliacaoProjeto from '../../modules/avaliacaoProjetos/questoesAvaliacaoProjeto.vue'
  import ChecklistIndicadores from '../../modules/checklistIndicadores.vue'
  import ChecklistAnalise from '../../modules/checklistAnalise.vue'
  import ParecerJuridicoCampos from '../../modules/parecerJuridicoCampos.vue'
  import QuadroRestricoesEntidade from '../../modules/quadroRestricoesEntidade.vue'
  import { respostasLegadasParaImportar } from '../../../mixins/checklistAnalise'
  import { mapGetters } from 'vuex'

  // Ação estratégica preenchida pelo sistema conforme os municípios da proposta
  const DIRECIONADOR_REALIDADES_LOCAIS = 'Conhecer as Realidades Locais'

  export default {
    name: 'analise',
    components: {
      Rating,
      QuestionarioRiscos,
      RelatorioAnalise,
      Fav,
      Categorizadores,
      Fep,
      UploadDocumentosPhpNovo,
      AgenciaCondutoraProjeto,
      odsMarcacao,
      licenciamentoAmbientalAnalise,
      questoesAvaliacaoProjeto,
      ChecklistIndicadores,
      ChecklistAnalise,
      ParecerJuridicoCampos,
      QuadroRestricoesEntidade
    },
    props: ['propsAnalise', 'propsFluxo', 'resultadoAprovacao', 'setPropostaSimplificada', 'restricoesEntidade'],
    data () {
      return {
        // Roteiros sugeridos para o preenchimento dos campos Histórico da Proponente e Análise
        placeholderHistoricoProponente: 'Quantos anos de existência tem a proponente?\nCite as principais experiências de atuação na mesma temática do projeto.\nCite demais principais realizações e parcerias da proponente.\nInformar brevemente sobre a capacidade técnica e operacional da estrutura atual da proponente.',
        placeholderAnalise: 'Construir um breve resumo, a partir das informações constantes na proposta, em que evidencie: o que será feito pela proponente para solucionar cada problema levantado, quais as parcerias serão firmadas para a execução do projeto, qual a importância desse projeto para a comunidade que será impactada, a sustentabilidade das ações do projeto e demais informações relevantes.',
        numeroFepInformado: null,
        resultadoVerificacaoFepExistente: '',
        elementos: {
          visivel: ''
        },
        // rating: [],
        questRiscKey: 0,
        showModal: false,
        rating: {},
        notaRating: '',
        ratingTemp: {},
        preenchimentoRelatorio: '',
        bloqueia: false,
        reportPeriodicity: [
          {id: 'SEMESTRAL', name: 'SEMESTRAL'},
          {id: 'QUADRIMESTRAL', name: 'QUADRIMESTRAL'},
          {id: 'TRIMESTRAL', name: 'TRIMESTRAL'},
          {id: 'BIMESTRAL', name: 'BIMESTRAL'},
          {id: 'MENSAL', name: 'MENSAL'}
        ],
        documentosAnalise: [],
        approval: {},
        analise: {
          questionario_respostas: {},
          ratingRelatorio: [],
          documentos: {
            analise: []
          }
        },
        formalizacaoDcto: [],
        dctos: [],
        aguardaEnviar: 0,
        requiredFormalizationDocumentsType: [],
        defaultDocumentTypeWorkPlan: null,
        defaultDocumentTypeDraft: null,
        documentosObrigatorios: ['Minuta', 'Plano de Trabalho', 'CADIN', 'Certidão Negativa de Débitos Trabalhistas - CNDT'],
        documentosObrigatoriosSimplificado: ['Minuta', 'Plano de Trabalho', 'CADIN', 'Certidão Negativa de Débitos Trabalhistas - CNDT', 'CND', 'Certidão junto a Controladoria Geral da União (CNEP/CEPIM)', 'Litígio com o BB (Portal Jurídico)'],
        indicativoAvaliacao: '',
        exibeQuestionario: '',
        // Indicativos de simplificação de proposta
        faixasInvestimento: [{faixa: 1, de: 0, para: 100000, alcada: 'Comitê de Desenvolvimento Social'}, {faixa: 2, de: 100000.01, para: 300000, alcada: 'Comitê de Desenvolvimento Social'}, {faixa: 3, de: 300000.01, para: 1000000000, alcada: 'Comitê Estratégico'}],
        totalFBB: 0,
        totalContrapartida: 0,
        totalParceiro: 0,
        faixaDoProjeto: 0,
        ehSimplificada: false,
        // Campos estratégicos (mockup - visíveis apenas para FUNDACAO a partir de ANALISE)
        direcionadoresEstrategicosOpcoes: [
          'Conhecer as Realidades Locais',
          'Mudanças Climáticas',
          'Priorização de Atuação',
          'Diversidade em Todas as Esferas'
        ],
        // Textos informativos exibidos no ícone de interrogação de cada ação estratégica
        direcionadoresEstrategicosAjuda: {
          'Mudanças Climáticas': 'Ênfase em temáticas da descarbonização, da economia circular e da transição energética, enfrentamento da emergência climática, incluindo ações de Ajuda Humanitária (Enchentes), na preservação e recuperação dos biomas brasileiros, fortalecimento da resiliência das comunidades frente às mudanças climáticas.',
          'Conhecer as Realidades Locais': 'Ênfase em comunidades, regiões e territórios onde ainda não atuamos. (Item selecionado de forma automática conforme municípios atendidos pelo projeto)',
          'Diversidade em Todas as Esferas': 'Compreendemos que a inclusão de grupos sub-representados é fundamental para contribuir em uma mudança mais ampla e significativa da sociedade. Promovemos ativamente a diversidade e oferecemos oportunidades que visam minimizar as desigualdades sociais. (Tema transversal)',
          'Priorização de Atuação': 'Eixos prioritários de atuação: Ênfase na redução das desigualdades, geração de renda, combate à insegurança alimentar, preservação e recuperação da biodiversidade de biomas, educação para o trabalho, inclusão digital, esporte, cultura, atenção à saúde, saneamento e acesso à água de qualidade.'
        },
        // Municípios da proposta sem projeto anterior da Fundação (api propostas/{id}/municipios-novos)
        municipiosNovos: [],
        // Mapa { valorPrograma => [indicadores] } carregado da config (api/indicadores-por-programa)
        indicadoresPorProgramaMapa: {},
        // Textos de plano de comunicação por faixa (config gerenciada em /admin)
        planosComunicacao: {},
        // Povos indígenas e quilombolas selecionáveis (configs gerenciadas em /admin)
        povosIndigenasOpcoes: [],
        povosQuilombolasOpcoes: [],
        caracteristicasGeograficasOpcoes: [
          'Rural', 'Urbana', 'Periurbana', 'Região costeira', 'Região ribeirinha'
        ],
        biomasOpcoes: [
          'Caatinga', 'Cerrado', 'Mata Atlântica', 'Pantanal', 'Pampa', 'Amazônia'
        ],
        tematicaProjetoOpcoes: [
          'Agroecologia', 'Povos Tradicionais', 'Agroindústria', 'Resíduos Sólidos', 'Economia Solidária',
          'Transição Energética Justa', 'Empreendedorismo', 'Igualdade Racial', 'Combate à Violência de Gênero', 'Outros'
        ]
      }
    },
    inject: ['$validator'],
    provide () {
      return {
        $validator: this.$validator
      }
    },
    computed: {
      ...mapGetters([
        'usuarioLogado'
      ]),
      // Simplificado conforme a MESMA regra do novo relatório de análise:
      // valor do projeto sem a contrapartida (Fundação BB + parceiro estratégico)
      // <= R$ 300.000,00. Usado apenas para ocultar os campos novos que só aparecem no
      // relatório completo (não afeta o ehSimplificada legado, que controla Rating/avaliação).
      ehSimplificadaRelatorio () {
        return (this.totalFBB || 0) + (this.totalParceiro || 0) <= 300000
      },
      // Proposta atende pelo menos um município sem projeto anterior da Fundação
      possuiMunicipioNovo () {
        return this.municipiosNovos.length > 0
      },
      tematicaOutrosSelecionado () {
        let selecionadas = (this.analise && this.analise.dados && this.analise.dados.tematica_projeto) || []
        return selecionadas.indexOf('Outros') !== -1
      },
      // Indicadores recomendados para o Programa selecionado (analise.ds_categ_programa)
      opcoesIndicadores () {
        let programa = this.analise ? this.analise.ds_categ_programa : null
        if (programa === null || programa === undefined) {
          return []
        }
        return this.indicadoresPorProgramaMapa[programa] || []
      }
    },
    watch: {
      documentosAnalise () {
        if (this.documentosAnalise) {
          this.analise.documentos.analise = this.documentosAnalise
        }
      },
      propsAnalise () {
        this.analise = this.propsAnalise
        this.moveDados()
        this.calculaTotaisEFaixaProjeto()
        this.sincronizaRealidadesLocais()
      },
      propsFluxo () {
        this.elementos = this.propsFluxo.elementos
      },
      // Ao informar números/datas do parecer jurídico, preenche a observação do
      // checklist (Enquadramento e Parecer Jurídico) com uma minuta, se vazia.
      'analise.dt_data_cmj': 'preencheMinutaParecer',
      'analise.ds_cmj': 'preencheMinutaParecer',
      'analise.dt_data_parecer_juridico': 'preencheMinutaParecer',
      'analise.ds_parecer_juridico': 'preencheMinutaParecer'
    },
    updated () {
      if (this.$refs.questoesAvaliacao && !this.$refs.questoesAvaliacao._isEventListenerAdded) {
        this.$refs.questoesAvaliacao.$on('indicativo-codigo-updated', this.updateCategAvaliacao)
        this.$refs.questoesAvaliacao._isEventListenerAdded = true // Marcar que o listener foi adicionado
      }
    },
    created () {
      if (this.$route.name === 'proposta-visualiza') {
        this.bloqueia = true
      }
      if (_.isEmpty(this.$store.state.configuracoes)) {
        axiosLaravel.get('configuracoes/').then((response) => {
          this.$store.commit('SET_CONFIGURACOES', response.data)
          this.setConfiguracoes(this.$store.state.configuracoes)
        })
          .catch((error) => {
            this.$root.trataErro(error)
          })
      } else {
        this.setConfiguracoes(this.$store.state.configuracoes)
      }
      // Monta origem da proposta
      if (!this.analise.questionario_respostas || this.analise.questionario_respostas.length === 0) {
        this.analise.questionario_respostas = {}
      }
      // Carrega o mapa de indicadores recomendados por Programa (config gerenciada em /admin)
      this.carregaIndicadoresPorPrograma()
      // Carrega os textos de plano de comunicação por faixa (config gerenciada em /admin)
      this.carregaPlanosComunicacao()
      // Carrega as listas de povos indígenas e quilombolas (configs gerenciadas em /admin)
      this.carregaPovos()
      // Carrega os municípios novos da proposta (marcação automática da ação estratégica)
      this.carregaMunicipiosNovos()
    },
    mounted () {
      this.recalcula()
      this.analise = this.propsAnalise
      this.moveDados()
      this.calculaTotaisEFaixaProjeto()
      this.sincronizaRealidadesLocais()
    },
    methods: {
      async criaNovaFep (numeroFepInformado) {
        this.resultadoVerificacaoFepExistente = 'Verificando número da FEP...'
        await axiosLaravel.get(`fep/verifica_numero/${numeroFepInformado}`).then((response) => {
          console.log('Verifica FEP - response.data: ', response.data)
          if (response.data.fepDisponivel === false) {
            this.resultadoVerificacaoFepExistente = 'Número FEP já existe para o ano vigente'
          } else {
            this.resultadoVerificacaoFepExistente = 'FEP disponível'
            this.$dialog.confirm(`Número de FEP disponível. Deseja gerar a FEP <b> ${numeroFepInformado}</b> para a proposta <b>${this.analise.ds_nome}</b>?`, {html: true, animation: 'fade', customClass: 'avisoAlerta'})
            .then(dialog => {
              this.$aguarde('Criando FEP para a proposta...')
              axiosLaravel.post('fep', {'fk_proposta': this.analise.id, 'numero': numeroFepInformado}).then((response) => {
                console.log('post.NovaFep')
                console.log(this.analise)
                console.log('response', response)
                this.$snotify.clear()
                this.$snotify.success('FEP gerada com sucesso')
                return new Promise(resolve => setTimeout(resolve, 1000)).then(() => {
                  this.$router.go()
                })
              })
            .catch((error) => {
              this.$snotify.clear()
              this.$root.trataErro(error)
            })
            })
          }
        })
      },
      moveDados () {
        // Garante a estrutura chave-valor (analise.dados) reativa para os novos campos.
        // Importante: quando a proposta não tem dados, o backend devolve `[]` (array vazio);
        // propriedades nomeadas num array NÃO sobrevivem ao JSON.stringify do save, então
        // coagimos para objeto quando vier ausente ou como array.
        if (!this.analise.dados || Array.isArray(this.analise.dados)) {
          this.$set(this.analise, 'dados', {})
        }
        // Inicialização e importação dos novos campos
        if (!Array.isArray(this.analise.dados.indicadores_resultado)) {
          this.$set(this.analise.dados, 'indicadores_resultado', [])
        }
        if (!Array.isArray(this.analise.dados.povos_indigenas)) {
          // Compatibilidade: aproveita o que foi gravado sob a chave antiga (povos_tradicionais_indigenas)
          let legado = Array.isArray(this.analise.dados.povos_tradicionais_indigenas) ? this.analise.dados.povos_tradicionais_indigenas : []
          this.$set(this.analise.dados, 'povos_indigenas', [...legado])
        }
        if (!Array.isArray(this.analise.dados.povos_quilombolas)) {
          this.$set(this.analise.dados, 'povos_quilombolas', [])
        }
        if (typeof this.analise.dados.comunicadores_populares !== 'boolean') {
          this.$set(this.analise.dados, 'comunicadores_populares', false)
        }
        if (typeof this.analise.dados.dirigente_indigena_quilombola !== 'boolean') {
          this.$set(this.analise.dados, 'dirigente_indigena_quilombola', false)
        }
        // Novos campos da análise (estrutura chave-valor tb_proposta_dado)
        if (typeof this.analise.dados.historico_proponente !== 'string') {
          this.$set(this.analise.dados, 'historico_proponente', '')
        }
        if (typeof this.analise.dados.analise_tecnica !== 'string') {
          this.$set(this.analise.dados, 'analise_tecnica', '')
        }
        if (typeof this.analise.dados.analise !== 'string') {
          this.$set(this.analise.dados, 'analise', '')
        }
        if (typeof this.analise.dados.situacao_problema !== 'string') {
          this.$set(this.analise.dados, 'situacao_problema', '')
        }
        if (typeof this.analise.dados.perfil_territorial !== 'string') {
          this.$set(this.analise.dados, 'perfil_territorial', '')
        }
        if (typeof this.analise.dados.objeto_convenio !== 'string') {
          this.$set(this.analise.dados, 'objeto_convenio', '')
        }
        if (!Array.isArray(this.analise.dados.contexto_caracteristicas_geograficas)) {
          this.$set(this.analise.dados, 'contexto_caracteristicas_geograficas', [])
        }
        if (!Array.isArray(this.analise.dados.contexto_biomas)) {
          this.$set(this.analise.dados, 'contexto_biomas', [])
        }
        if (!Array.isArray(this.analise.dados.tematica_projeto)) {
          this.$set(this.analise.dados, 'tematica_projeto', [])
        }
        if (typeof this.analise.dados.tematica_projeto_outros !== 'string') {
          this.$set(this.analise.dados, 'tematica_projeto_outros', '')
        }
        if (!Array.isArray(this.analise.dados.pontos_atencao_mitigadores) || !this.analise.dados.pontos_atencao_mitigadores.length) {
          this.$set(this.analise.dados, 'pontos_atencao_mitigadores', [{ risco: '', mitigador: '' }])
        }
        if (typeof this.analise.dados.condicionantes !== 'string') {
          this.$set(this.analise.dados, 'condicionantes', '')
        }
        if (!Array.isArray(this.analise.dados.direcionadores_estrategicos)) {
          this.$set(this.analise.dados, 'direcionadores_estrategicos', [])
        }
        if (typeof this.analise.dados.conclusao_analise !== 'string') {
          this.$set(this.analise.dados, 'conclusao_analise', '')
        }
        // Conclusão da Análise: se vazia, herda o parecer da estrutura legada
        // (coluna ds_relatorio_analise_parecer ou ds_parecer do JSON do relatório antigo).
        if (this.analise.dados.conclusao_analise === '') {
          let parecerLegado = this.analise.ds_relatorio_analise_parecer
          if (!parecerLegado && this.analise.relatorio_analise) {
            try {
              let ra = typeof this.analise.relatorio_analise === 'string'
                ? JSON.parse(this.analise.relatorio_analise)
                : this.analise.relatorio_analise
              parecerLegado = ra && ra.ds_parecer
            } catch (e) {
              parecerLegado = null
            }
          }
          if (parecerLegado) {
            this.$set(this.analise.dados, 'conclusao_analise', parecerLegado)
          }
        }
        // Importa as respostas do relatório de análise legado (JSON antigo) para
        // as chaves novas do checklist — somente quando o campo novo está vazio.
        let respostasLegadas = respostasLegadasParaImportar(this.analise)
        Object.keys(respostasLegadas).forEach((chave) => {
          this.$set(this.analise.dados, chave, respostasLegadas[chave])
        })
        // Preenche a minuta do parecer jurídico se a observação estiver vazia
        this.preencheMinutaParecer()
        if (this.analise.documentos) {
          if (_.isUndefined(this.analise.documentos.analise) || this.analise.documentos.analise.length <= 0) {
            // O correto é usar o dctos, mas ele não carrega no momento correto (aqui aparece vazio), então foi colocados os tipos de arquivos de análise fixos no array abaixo
            let idTiposDocumentosAnalise = [7, 8]// _.map(this.dctos, 'id')
            let documentosAnalise = _.filter(this.propsAnalise.documentos.proposta, function (doc) {
              return _.includes(idTiposDocumentosAnalise, doc.fk_tipo_documento)
            })
            this.analise.documentos.analise = documentosAnalise
          }
          this.documentosAnalise = this.analise.documentos.analise
        }
        this.$emit('analiseProposta', this.analise)
        // só move se vier algo preenchido.
        if (this.analise.relatorio_analise) {
          if (!_.isNull(this.analise.relatorio_analise) && !_.isUndefined(this.analise.relatorio_analise)) {
            this.relatorioAnalise = JSON.parse(this.analise.relatorio_analise)
          }
        }
        let result = 0
        if (!_.isNull(this.relatorioAnalise) && !_.isUndefined(this.relatorioAnalise)) {
          result = Object.keys(this.relatorioAnalise).length
        }
        let total = 63
        if (_.isEmpty(this.relatorioAnalise)) {
          this.preenchimentoRelatorio = 'Não Preenchido'
        }
        if (result < total) {
          this.preenchimentoRelatorio = 'Em Preenchimento'
        }
        if (result >= total) {
          this.preenchimentoRelatorio = 'Preenchido'
        }
        // this.analise.documentosFormalizacao = this.formalizacaoDcto
        this.approval = this.analise
        // this.carregaArquivos()
        this.$emit('analiseProposta', this.analise)
        this.$emit('etapa', this.analise.ds_fase)
        this.$forceUpdate()
      },
      setConfiguracoes (data) {
        let generalSystemConfig = data
        let minuta = data.configuracao_proposta.minuta
        let planoTrabalho = data.configuracao_proposta.plano_trabalho
        this.dctos.push(minuta, planoTrabalho)
        if (generalSystemConfig.configuracao_proposta) {
          this.requiredFormalizationDocumentsType = []

          if (generalSystemConfig.configuracao_proposta.minuta) {
            this.requiredFormalizationDocumentsType.push(generalSystemConfig.configuracao_proposta.minuta)
            this.defaultDocumentTypeDraft = generalSystemConfig.configuracao_proposta.minuta
          }
          if (generalSystemConfig.configuracao_proposta.plano_trabalho) {
            this.requiredFormalizationDocumentsType.push(generalSystemConfig.configuracao_proposta.plano_trabalho)
            this.defaultDocumentTypeWorkPlan = generalSystemConfig.configuracao_proposta.plano_trabalho
          }
        }
      },
      recalcula () {
        // let existe = _.has(this.analise, 'ratingRelatorio')
        let rat = {}
        let bc = new BroadcastChannel('test_channel')
        let self = this
        bc.onmessage = function (ev) {
          rat = ev.data
          this.notaRating = rat.classificacao.nota
          self.ratingTemp = rat
          self.analise.ratingRelatorio = self.ratingTemp
        }
        this.ratingTemp = self.ratingTemp
      },
      mostrarRef (ref) {
        return _.filter(this.elementos, item => item.nome === ref).some((item) => { return item.visivel })
      },
      onReturn () {
        this.$router.go(-1)
      },
      carregaArquivos () {
        this.analise.formalizationDocuments = []
        if (this.analise.proposal.documentDraft) {
          this.analise.formalizationDocuments.push(this.analise.proposal.documentDraft)
        }
        if (this.analise.proposal.documentWorkPlan) {
          this.analise.formalizationDocuments.push(this.analise.proposal.documentWorkPlan)
        }
      },
      Aprova () {
        // Valida se os documentos obrigatórios foram enviados
        if (!this.verificaDocumentosCarregados()) {
          this.$snotify.error('Existem documentos pendentes')
          return
        }
        // Verifica se os dados da proposta estão ok
        if (!this.$root.validaProposta(this.analise.proposal)) {
          return
        }
        this.$parent.$validator.validateAll().then(async (validado) => {
          if (!validado) {
            this.$snotify.error('Formulario de proposta possui erros favor verificar')
            return
          }
          // Verifica se algum componente filho tem algum erro
          if (await this.$root.verificaFormulario(this)) {
            this.$snotify.error('Formulario possui erros favor verificar')
            return
          }
          this.$validator.validateAll().then((validado) => {
            if (!validado) {
              this.$snotify.error('Formulario possui erros favor verificar')
            } else {
              // this.enviaBackEnd()
            }
          })
        })
      },
      enviaBackEnd () {
        // anexa a proposta na analise
        this.aguardaEnviar = 1
        this.$aguarde('Validando proposta. Por favor, aguarde...')
        axios.put('proxy/project/approval-analysis/' + this.approval.id + '/approve', this.approval).then((response) => {
          this.$snotify.clear()
          this.$snotify.success('Analise atualizada com sucesso')
          setTimeout(() => { this.$router.go(-1) }, 2000)
        })
          .catch((error) => {
            this.aguardaEnviar = 0
            this.$snotify.clear()
            this.$root.trataErro(error)
          })
      },
      getTiposDocumentoSimplificado () {
        // anexa a proposta na analise
        let obj = {
          lista: this.documentosObrigatoriosSimplificado
        }
        axiosLaravel.post('/simplificado/retornarTipoDocumentoSimplificado/', obj).then((response) => {
          if (response.data) {
            this.dctos = response.data
          }
          this.$snotify.clear()
        })
          .catch((error) => {
            this.$root.trataErro(error)
          })
      },
      validaContaFinanceira () {
        let ITEM = null
        this.analise.proposal.objectives.forEach(objetivo => {
          objetivo.goals.forEach(meta => {
            meta.activities.forEach(atividade => {
              atividade.items.forEach(item => {
                if (!item.financialAccount || item.financialAccount === '') {
                  ITEM = item
                  this.$snotify.warning('Falta conta financeira no item "' + ITEM.itemDescription + '"', {timeout: 10000})
                }
              })
            })
          })
        })
        return ITEM
      },
      validaMunicipalizacao () {
        let CIDADE = null
        this.analise.proposal.municipalizationResume.forEach(cidade => {
          if (!cidade.phase || cidade.phase === '') {
            CIDADE = cidade
            this.$snotify.warning('A Municipalização da cidade ' + cidade.name + ' é de preenchimento obrigatório!')
          }
        })
        return CIDADE
      },
      // Valida se todos os documentos foram adicionados
      verificaDocumentosCarregados () {
        if (!this.analise.formalizationDocuments) {
          return false
        }
        let documentosCarregados = this.analise.formalizationDocuments.map((item) => {
          return item.documentType.type
        })
        return _.isEqual(this.documentosObrigatorios.sort(), documentosCarregados.sort())
      },
      limparInfo () {
        if (this.analise.resultadoAprovacao === 'ENCAMINHAR_DEFERIMENTO' || this.analise.resultadoAprovacao === 'INCLUIR_SAPIENS') {
          this.analise.observacao = ''
        }
      },
      moveDocumentosFormalizacao () {
        // Retira a minuta e o plano de trabalho do objeto para depois preencher novamente se for o caso
        // Isso é feito para não dar problema nas ligações dos objetos java
        delete this.analise.proposal.documentDraft
        delete this.analise.proposal.documentWorkPlan
        // Varre o array para mover os dados conforme o tipo
        this.analise.formalizationDocuments.forEach((documento) => {
          if (documento.documentType.type === 'Minuta') {
            this.analise.proposal.documentDraft = documento
          } else {
            this.analise.proposal.documentWorkPlan = documento
          }
        })
      },
      updateCategAvaliacao (newVal) {
        console.log('UPDATE CATEG', newVal)
        this.indicativoAvaliacao = newVal
      },
      salvarAvaliacao (salvando = false) {
        if (!this.ehSimplificada && this.$refs.questoesAvaliacao) {
          return this.$refs.questoesAvaliacao.salvarPontuacao(salvando)
        }
      },
      verificaLicencas () {
        return this.$refs.licenciamentoAnalise.verificaLicencas()
      },
      // Temática do Projeto é obrigatória para concluir a análise (chamado por EditaProposta.permiteConcluir).
      // Em produção o campo não existe, então não bloqueia.
      // Monta a minuta (texto corrido) com os números e datas do parecer jurídico informados.
      montaMinutaParecer () {
        let cmj = (this.analise.ds_cmj || '').toString().trim()
        let dataCmj = (this.analise.dt_data_cmj || '').toString().trim()
        let parecer = (this.analise.ds_parecer_juridico || '').toString().trim()
        let dataParecer = (this.analise.dt_data_parecer_juridico || '').toString().trim()
        if (!cmj && !dataCmj && !parecer && !dataParecer) {
          return ''
        }
        return `Será utilizada minuta aprovada pela Diretoria Jurídica - DIJUR do Banco do Brasil S.A., por meio do Parecer Jurídico nº ${parecer} de ${dataParecer}. Data CMJ ${dataCmj}. Número do CMJ: ${cmj}.`
      },
      // Preenche a observação do parecer jurídico (checklist) com a minuta, somente se estiver vazia.
      preencheMinutaParecer () {
        if (!this.analise || !this.analise.dados) {
          return
        }
        let atual = this.analise.dados.ds_enquadramento_observacoes
        if (atual !== null && atual !== undefined && atual !== '') {
          return
        }
        let minuta = this.montaMinutaParecer()
        if (minuta) {
          this.$set(this.analise.dados, 'ds_enquadramento_observacoes', minuta)
        }
      },
      verificaTematicaProjeto () {
        let selecionadas = (this.analise && this.analise.dados && this.analise.dados.tematica_projeto) || []
        if (!selecionadas.length) {
          return false
        }
        if (selecionadas.indexOf('Outros') !== -1 && !(this.analise.dados.tematica_projeto_outros || '').trim()) {
          return false
        }
        return true
      },
      // salvarAvaliacao () {
      //   if (!this.ehSimplificada) {
      //     return this.$refs.questoesAvaliacao.salvarPontuacao()
      //   }
      // },
      carregaIndicadoresPorPrograma () {
        axiosLaravel.get('indicadores-por-programa').then((response) => {
          // O endpoint retorna o JSON (string ou objeto) do mapa { valorPrograma: [indicadores] }
          let mapa = response.data
          if (typeof mapa === 'string') {
            mapa = mapa ? JSON.parse(mapa) : {}
          }
          this.indicadoresPorProgramaMapa = mapa || {}
        })
          .catch((error) => {
            this.$root.trataErro(error)
          })
      },
      carregaPlanosComunicacao () {
        axiosLaravel.get('planos-comunicacao').then((response) => {
          this.planosComunicacao = response.data || {}
          // Os totais podem já ter sido calculados antes desta resposta chegar
          this.preencheAcoesComunicacao()
        })
          .catch((error) => {
            this.$root.trataErro(error)
          })
      },
      // Carrega os municípios da proposta que nunca tiveram projeto da Fundação.
      // A ação estratégica "Conhecer as Realidades Locais" é marcada a partir disso.
      carregaMunicipiosNovos () {
        let id = this.$route.params.id
        if (!id) {
          return
        }
        axiosLaravel.get(`propostas/${id}/municipios-novos`).then((response) => {
          this.municipiosNovos = (response.data && response.data.municipios_novos) || []
          this.sincronizaRealidadesLocais()
        })
          .catch(() => {
            // Base histórica indisponível: não marca nada e não interrompe a análise.
            this.municipiosNovos = []
          })
      },
      // Ações estratégicas preenchidas pelo sistema (usuário não marca nem desmarca)
      ehDirecionadorAutomatico (item) {
        return item === DIRECIONADOR_REALIDADES_LOCAIS
      },
      textoAjudaDirecionador (item) {
        return this.direcionadoresEstrategicosAjuda[item] || ''
      },
      // Mantém "Conhecer as Realidades Locais" marcada somente quando a proposta
      // tem pelo menos um município novo e descarta marcações de opções que
      // deixaram de existir (Tecnologia Social, ODS, Priorização de Público).
      sincronizaRealidadesLocais () {
        if (!this.analise || !this.analise.dados || !Array.isArray(this.analise.dados.direcionadores_estrategicos)) {
          return
        }
        let marcados = this.analise.dados.direcionadores_estrategicos
        for (let i = marcados.length - 1; i >= 0; i--) {
          if (this.direcionadoresEstrategicosOpcoes.indexOf(marcados[i]) === -1) {
            marcados.splice(i, 1)
          }
        }
        let posicao = marcados.indexOf(DIRECIONADOR_REALIDADES_LOCAIS)
        if (this.possuiMunicipioNovo && posicao === -1) {
          marcados.push(DIRECIONADOR_REALIDADES_LOCAIS)
        } else if (!this.possuiMunicipioNovo && posicao !== -1) {
          marcados.splice(posicao, 1)
        }
      },
      carregaPovos () {
        axiosLaravel.get('povos').then((response) => {
          this.povosIndigenasOpcoes = (response.data && response.data.povos_indigenas) || []
          this.povosQuilombolasOpcoes = (response.data && response.data.povos_quilombolas) || []
        })
          .catch((error) => {
            this.$root.trataErro(error)
          })
      },
      // Adiciona um povo não cadastrado (digitado pelo usuário) à lista de opções e à seleção
      adicionaPovo (novoPovo, opcoes, selecionados) {
        let povo = (novoPovo || '').trim()
        if (!povo) {
          return
        }
        if (!opcoes.includes(povo)) {
          opcoes.push(povo)
        }
        if (!selecionados.includes(povo)) {
          selecionados.push(povo)
        }
      },
      adicionaPovoIndigena (novoPovo) {
        this.adicionaPovo(novoPovo, this.povosIndigenasOpcoes, this.analise.dados.povos_indigenas)
      },
      adicionaPovoQuilombola (novoPovo) {
        this.adicionaPovo(novoPovo, this.povosQuilombolasOpcoes, this.analise.dados.povos_quilombolas)
      },
      // Pré-preenche "Ações de Comunicação" (quando vazio) com o texto da config
      // conforme a faixa de valor total do projeto:
      //   até 300 mil          -> plano_comunicacao_1
      //   > 300 mil a 1 milhão  -> plano_comunicacao_2
      //   > 1 milhão a 2 milhões -> plano_comunicacao_3
      //   > 2 milhões           -> plano_comunicacao_4
      preencheAcoesComunicacao () {
        if (!this.analise) {
          return
        }
        let atual = this.analise.ds_acoes_comunicacao
        if (atual !== null && atual !== undefined && atual !== '') {
          return
        }
        let totalProjeto = (this.totalFBB || 0) + (this.totalParceiro || 0)
        let chave
        if (totalProjeto <= 300000) {
          chave = 'plano_comunicacao_1'
        } else if (totalProjeto <= 1000000) {
          chave = 'plano_comunicacao_2'
        } else if (totalProjeto <= 2000000) {
          chave = 'plano_comunicacao_3'
        } else {
          chave = 'plano_comunicacao_4'
        }
        let texto = this.planosComunicacao[chave]
        if (texto) {
          this.$set(this.analise, 'ds_acoes_comunicacao', texto)
        }
      },
      // Monta a Distribuição e Informações dos Recursos (chave analise_tecnica) com uma linha por atividade e o valor
      // somado dos seus itens de orçamento. Usado no pré-preenchimento e no botão
      // "Gerar novamente" (que substitui o texto atual).
      geraAnaliseTecnica () {
        const fmt = v => 'R$ ' + (v || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        let linhas = (this.analise.atividades || []).map((atividade) => {
          let soma = 0
          if (atividade.itens_orcamentos) {
            atividade.itens_orcamentos.forEach((item) => {
              soma += (Number(item.valor_unitario) || 0) * (Number(item.quantidade) || 0)
            })
          }
          return `${atividade.ds_nome || 'Atividade'} — ${fmt(soma)}`
        })
        if (linhas.length) {
          this.$set(this.analise.dados, 'analise_tecnica', linhas.join('\n'))
        }
      },
      addRiscoMitigador () {
        this.analise.dados.pontos_atencao_mitigadores.push({risco: '', mitigador: ''})
      },
      removeRiscoMitigador (index) {
        if (this.analise.dados.pontos_atencao_mitigadores.length > 1) {
          this.analise.dados.pontos_atencao_mitigadores.splice(index, 1)
        }
      },
      calculaTotaisEFaixaProjeto () {
        console.log('calculaTotaisEFaixaProjeto')
        this.totalFBB = 0
        this.totalContrapartida = 0
        this.totalParceiro = 0
        this.analise.atividades.forEach((atividade) => {
          // se a atividade tem itens_orcamento sem valor ignora!
          if (atividade.itens_orcamentos) {
            atividade.itens_orcamentos.forEach((item) => {
              if (('' + item.origem) === '1') {
                this.totalFBB += (item.valor_unitario * item.quantidade)
              }
              if (('' + item.origem) === '2') {
                this.totalContrapartida += (item.valor_unitario * item.quantidade)
              }
              if (('' + item.origem) === '5') {
                this.totalParceiro += (item.valor_unitario * item.quantidade)
              }
            })
          }
        })
        let totalProjeto = this.totalFBB + this.totalParceiro
        console.log('calculaTotaisEFaixaProjeto-total: ', totalProjeto)
        this.faixaDoProjeto = _.find(this.faixasInvestimento, function (faixa) { return faixa.de <= totalProjeto && totalProjeto <= faixa.para })
        console.log('calculaTotaisEFaixaProjeto-faixa: ', this.faixaDoProjeto.faixa)
        this.ehSimplificada = _.includes([1, 2], this.faixaDoProjeto.faixa)
        if (this.analise.dados && !this.analise.dados.conclusao_analise) {
          const fmt = v => 'R$ ' + (v || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
          this.$set(this.analise.dados, 'conclusao_analise', `Propomos o deferimento de recursos financeiros no valor de ${fmt(this.totalFBB)} conforme registros realizados no Sistema Corporativo da Fundação BB, com contrapartida no valor de ${fmt(this.totalContrapartida)} necessários para viabilizar a execução das ações a serem desenvolvidas`)
        }
        // Pré-preenche a Distribuição e Informações dos Recursos (quando vazia) com as atividades.
        if (this.analise.dados && !this.analise.dados.analise_tecnica) {
          this.geraAnaliseTecnica()
        }
        if (this.ehSimplificada) {
          this.getTiposDocumentoSimplificado()
          this.$emit('setPropostaSimplificada', 'C')
          // if (this.propsAnalise.fk_edital === 12) {
          //   this.analise.ds_periodicidade_formulario = 'SEMESTRAL'
          // } else {
          this.analise.ds_periodicidade_formulario = 'QUADRIMESTRAL'
          // }
          this.questRiscKey++
        }
        // Pré-preenche as Ações de Comunicação (se vazio) conforme a faixa do total
        this.preencheAcoesComunicacao()
      }
    }
  }
</script>

<style scoped>
  /* Ícone de ajuda das ações estratégicas: o texto aparece imediatamente no hover */
  .ajuda-direcionador {
    position: relative;
    display: inline-block;
    margin-left: 4px;
    color: #048019;
    cursor: help;
  }
  .ajuda-direcionador-texto {
    display: none;
    position: absolute;
    z-index: 10000;
    left: 18px;
    top: -4px;
    max-width: calc(100vw - 60px);
    width: 340px;
    padding: 8px 10px;
    background-color: #333;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 1.4;
    text-align: left;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  }
  .ajuda-direcionador:hover .ajuda-direcionador-texto {
    display: block;
  }
  /* Na última coluna da grade o texto abre para a esquerda, para não cortar na borda da tela */
  .ajuda-direcionador-esquerda .ajuda-direcionador-texto {
    left: auto;
    right: 18px;
  }
  .modal-mask {
    position: fixed;
    z-index: 9999;
    overflow-y: scroll;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }
  .modal-wrapper {
    display: inherit;
    vertical-align: auto;

  }
  .modal-dialog {
    width: 80%;

  }
  .riscoCalculado {
    font-weight: bold;
    font-size: 16px;
  }
  .mensagem {
    font-weight: bold;
    font-size: 16px;
  }
  .naoPreenchido {
    color: orangered;
  }

</style>



// WEBPACK FOOTER //
// analise.vue?4dcedf27